import type {
  WorklistCriterionType,
  WorklistPriorityRule,
} from '../services/worklistPriorityRuleService';
import { formatModalityDisplayLabel } from './modalityUtils';
import { parseStoredTestNames } from './testNameListUtils';

export const CRITERION_TYPE_OPTIONS: { value: WorklistCriterionType; label: string }[] = [
  { value: 'modality', label: 'Modality' },
  { value: 'order_priority', label: 'Order Priority' },
  { value: 'subspecialty', label: 'Subspecialty' },
  { value: 'tat_status', label: 'TAT Status' },
  { value: 'clinical_flag', label: 'Clinical Flag' },
];

/** Registration priorities — ROUTINE, URGENT, VIP, MLC */
export const ORDER_PRIORITY_OPTIONS = [
  { value: 'ROUTINE', label: 'ROUTINE' },
  { value: 'URGENT', label: 'URGENT' },
  { value: 'VIP', label: 'VIP' },
  { value: 'MLC', label: 'MLC' },
];

export const TAT_STATUS_OPTIONS = [
  { value: 'near_breach', label: 'Near to expire (<20% TAT left)' },
  { value: 'breached', label: 'TAT exceeded' },
];

export function formatCriterionTypeLabel(type: WorklistCriterionType): string {
  return CRITERION_TYPE_OPTIONS.find(option => option.value === type)?.label ?? type;
}

/** Table display — uppercase values for order priority and modality */
export function formatCriterionValueDisplay(rule: WorklistPriorityRule): string {
  if (rule.criterionValueDisplay?.trim()) {
    return rule.criterionValueDisplay;
  }

  switch (rule.criterionType) {
    case 'modality':
      return formatModalityDisplayLabel(
        rule.modality?.name ?? rule.criterionValue ?? ''
      ).toUpperCase();
    case 'order_priority':
      return (
        ORDER_PRIORITY_OPTIONS.find(option => option.value === rule.criterionValue?.toUpperCase())
          ?.label ??
        rule.criterionValue?.toUpperCase() ??
        ''
      );
    case 'subspecialty': {
      const names = parseStoredTestNames(rule.criterionValue);
      return names.length > 0 ? names.join(', ') : (rule.criterionValue ?? '');
    }
    case 'tat_status':
      return (
        TAT_STATUS_OPTIONS.find(option => option.value === rule.criterionValue)?.label ??
        rule.criterionValue
      );
    default:
      return rule.criterionValue ?? '';
  }
}

export function resolveModalityOptionValue(rule: WorklistPriorityRule): string {
  if (rule.modality?.name) {
    return rule.modality.name;
  }
  return rule.criterionValue ?? '';
}
